export const tags = (t) => [
    { id: 'categories', label: t('discover.category.tabs.categories') },
    { id: 'entities', label: t('discover.category.tabs.entities') },
    { id: 'authors', label: t('discover.category.tabs.authors') },
];
